<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'DATA_CYCLES', url: '/admin/data-cycles' },
    { label: 'CREATE_DATA_CYCLE' }
  ]"
></breadcrumbs>

<page-header title="CREATE_DATA_CYCLE"></page-header>

<card>
  <form class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="ACTIVE_FORM">{{
        'ACTIVE_FORM' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="forms"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.id, 'evaluationFormId')"
          [ngClass]="{ 'is-danger': hasError('activeFormId') }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['evaluationFormId'])"
          class="is-small"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('evaluationFormId')">
        {{ getError('evaluationFormId') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="START_DATE">{{
        'START_DATE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          type="date"
          (input)="handleFieldChange($event)"
          [value]="getField(['startDate'])"
          name="startDate"
          placeholder="Start Date"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('startDate')">
        {{ getError('startDate') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PROPOSED_END_DATE">{{
        'PROPOSED_END_DATE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          type="date"
          (input)="handleFieldChange($event)"
          [value]="getField(['proposedEndDate'])"
          name="proposedEndDate"
          [placeholder]="'Proposed End Date' | translate"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('proposedEndDate')">
        {{ getError('proposedEndDate') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PAYMENT_DEADLINE">{{
        'PAYMENT_DEADLINE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          type="date"
          (input)="handleFieldChange($event)"
          [value]="getField(['paymentDeadline'])"
          name="paymentDeadline"
          [placeholder]="'Proposed End Date' | translate"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('paymentDeadline')">
        {{ getError('paymentDeadline') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="RDN_EARLY_PAYMENT_DISCOUNT_DEADLINE"
        >{{ 'RDN_EARLY_PAYMENT_DISCOUNT_DEADLINE' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          type="date"
          (input)="handleFieldChange($event)"
          [value]="
            getField(['earlyPaymentDiscountDeadline'])
              | formatDate : 'yyyy-MM-DD'
          "
          name="earlyPaymentDiscountDeadline"
          [placeholder]="'Proposed End Date' | translate"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('earlyPaymentDiscountDeadline')"
      >
        {{ getError('earlyPaymentDiscountDeadline') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="RDN_EARLY_PAYMENT_DISCOUNT_PERCENTAGE"
        >{{ 'RDN_EARLY_PAYMENT_DISCOUNT_PERCENTAGE' | translate }}</label
      >
      <div class="control">
        <number-input
          name="earlyPaymentDiscountPercentage"
          (input)="handleFieldChange($event)"
          [value]="getField(['earlyPaymentDiscountPercentage'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('earlyPaymentDiscountPercentage')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('earlyPaymentDiscountPercentage')"
      >
        {{ getError('earlyPaymentDiscountPercentage') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="BUSINESS_EARLY_PAYMENT_DISCOUNT_DEADLINE"
        >{{ 'BUSINESS_EARLY_PAYMENT_DISCOUNT_DEADLINE' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          type="date"
          (input)="handleFieldChange($event)"
          [value]="
            getField(['earlyPaymentDiscountDeadlineBusiness'])
              | formatDate : 'yyyy-MM-DD'
          "
          name="earlyPaymentDiscountDeadlineBusiness"
          [placeholder]="'Proposed End Date' | translate"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('earlyPaymentDiscountDeadlineBusiness')"
      >
        {{ getError('earlyPaymentDiscountDeadlineBusiness') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="BUSINESS_EARLY_PAYMENT_DISCOUNT_PERCENTAGE"
        >{{ 'BUSINESS_EARLY_PAYMENT_DISCOUNT_PERCENTAGE' | translate }}</label
      >
      <div class="control">
        <number-input
          name="earlyPaymentDiscountPercentageBusiness"
          (input)="handleFieldChange($event)"
          [value]="getField(['earlyPaymentDiscountPercentageBusiness'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('earlyPaymentDiscountPercentageBusiness')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('earlyPaymentDiscountPercentageBusiness')"
      >
        {{ getError('earlyPaymentDiscountPercentageBusiness') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="COMPOUND_EARLY_PAYMENT_DISCOUNT_DEADLINE"
        >{{ 'COMPOUND_EARLY_PAYMENT_DISCOUNT_DEADLINE' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          type="date"
          (input)="handleFieldChange($event)"
          [value]="
            getField(['earlyPaymentDiscountDeadlineCompounds'])
              | formatDate : 'yyyy-MM-DD'
          "
          name="earlyPaymentDiscountDeadlineCompounds"
          [placeholder]="'Proposed End Date' | translate"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('earlyPaymentDiscountDeadlineCompounds')"
      >
        {{ getError('earlyPaymentDiscountDeadlineCompounds') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="COMPOUND_EARLY_PAYMENT_DISCOUNT_PERCENTAGE"
        >{{ 'COMPOUND_EARLY_PAYMENT_DISCOUNT_PERCENTAGE' | translate }}</label
      >
      <div class="control">
        <number-input
          name="earlyPaymentDiscountPercentageCompounds"
          (input)="handleFieldChange($event)"
          [value]="getField(['earlyPaymentDiscountPercentageCompounds'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('earlyPaymentDiscountPercentageCompounds')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('earlyPaymentDiscountPercentageCompounds')"
      >
        {{ getError('earlyPaymentDiscountPercentageCompounds') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="COMPOUND_PENALTY_PERCENTAGE"
        >{{ 'COMPOUND_PENALTY_PERCENTAGE' | translate }}</label
      >
      <div class="control">
        <number-input
          name="penaltyPercentageCompounds"
          (input)="handleFieldChange($event)"
          [value]="getField(['penaltyPercentageCompounds'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('penaltyPercentageCompounds')
          }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('penaltyPercentageCompounds')">
        {{ getError('penaltyPercentageCompounds') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SUBMIT"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/data-cycles']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
